const state = {
  brandList: [],
};

// getters
const getters = {
  getBrandList: () => {
    return state.brandList;
  },
};

// actions
const actions = {};

// mutations
const mutations = {
  updateBrandList: (state, list) => {
    state.brandList = list;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
